/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEaseInOut = createReactComponent("outline", "ease-in-out", "IconEaseInOut", [["path", { "d": "M3 20c8 0 10 -16 18 -16", "key": "svg-0" }]]);

export { IconEaseInOut as default };
//# sourceMappingURL=IconEaseInOut.mjs.map
